import { store } from "../../../../redux/store";
import {
  showLoading,
  hideLoading,
} from "../../../../connected-components/loader/reducer";
import { services } from "../../../../api";
import { toastService } from "../../../../shared/utils/toast";
import {
  AddPatientRequest,
  AddPatientResponse,
} from "../../../../interfaces/api/patients";

/**
 * Add a new patient action
 * @param {AddPatientRequest} body - Patient data
 * @returns {Promise<boolean>} Success status
 */
export const addPatient = async (body: AddPatientRequest): Promise<boolean> => {
  try {
    store.dispatch(showLoading());
    const res: AddPatientResponse = await services.patients.addPatient(body);
    if (!res || res.result !== "success" || !res.content) {
      toastService.showErrorToast(
        Array.isArray(res.error_description)
          ? res.error_description.join(", ")
          : "Failed to add patient",
      );
      return false;
    }
    toastService.showSuccessToast("Patient added successfully");
    return true;
  } catch (error) {
    // Error handled by http.tsx
    return false;
  } finally {
    store.dispatch(hideLoading());
  }
};
